// extracted by mini-css-extract-plugin
var _1 = "ClampingTextContentCSSClamp-moduleClampingTextContentCSSClamp__NCeio";
var _2 = "ClampingTextContentCSSClamp-moduleclamped__fvIfI";
var _3 = "ClampingTextContentCSSClamp-moduletext__cmjwV ClampingText-moduleclampingText__ANX4H";
export { _1 as "ClampingTextContentCSSClamp", _2 as "clamped", _3 as "text" }
